import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';

export const getAlumniData = async () => {
    try {
        const response = await ApiClient.get(`/AlumniPage/getAlumni`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}




// export const updateAlumniData = async ({ id, mission, vision, goals }) => {
//     try {
//         const response = await ApiClient.put(`/AlumniPage/updateAlumni/${id}`,
//             { id, mission, vision, goals },
//             {
//                 headers: {
//                     'Content-Type': 'multipart/form-data'
//                 }
//             });
//         console.log("response", response);
//         return response;
//     } catch (error) {
//         throw error;
//     }
// }


export const updateAlumniData = async ({ id, mission, vision, goals }) => {
    try {
      const response = await ApiClient.put(
        `/AlumniPage/updateAlumni/${id}`,
        { id, mission, vision, goals },
        {
          headers: {
            "Content-Type": "application/json", // Changed from multipart/form-data to application/json
          },
        }
      );
      console.log("response", response);
      return response;
    } catch (error) {
      throw error;
    }
  };